import restaurantInstance from '../../instance'

const fetchTableOrders = (tableId, ungroup = false, status ) => {
	const valueStatus = status ? ungroup ? `&itemStatus=${status}` : `?itemStatus=${status}` : ''
  return restaurantInstance.get(`/tables/${tableId}/orders` + (ungroup ? '?ungroup=true' : '') + (valueStatus))
}

export default fetchTableOrders
